define.alias("ember-truth-helpers/helpers/is-array", "media/helpers/is-array");